
import { COLOR }          from '@/constants/colors';
import { LEGEND_TYPES }     from '@/interfaces/SmartLink/General';
import i18n                 from '../../i18n/i18n';
import { computed, ComputedRef } from 'vue';

const ok: ComputedRef<string>        = computed(() => i18n.global.t('labels.ok'));
const alarma: ComputedRef<string>    = computed(() => i18n.global.t('labels.alarm'));
const alerta: ComputedRef<string>    = computed(() => i18n.global.t('labels.alert'));

export const FINAL_TYPE_LEGEND:LEGEND_TYPES = {
    quality_snr       : [
        {
            prinColor  : COLOR.green,
            secuColor  : 'rgb(62 97 57)',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : ok,
            secuText   : 'Mayor a 18dB',
        },
        {
            prinColor  : COLOR.yellow,
            secuColor  : '#B4A343',
            colorText1 : 'black',
            colorText2 : 'white',
            prinText   : alerta,
            secuText   : '18dB a 12dB'
        },
        {
            prinColor  : COLOR.red,
            secuColor  : '#8F3A36',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : alarma,
            secuText   : 'Menor a 12'
        },
    ],
    quality_lap        : [
        {
            prinColor  : COLOR.red,
            secuColor  : '#8F3A36',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : alarma,
            secuText   : '-90dBm a -80dBm'
        },
        {
            prinColor  : COLOR.yellow,
            secuColor  : '#B4A343',
            colorText1 : 'black',
            colorText2 : 'white',
            prinText   : alerta,
            secuText   : '-80dBm a -70dBm'
        },    
        {
            prinColor  : COLOR.green,
            secuColor  : 'rgb(62 97 57)',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : ok,
            secuText   : '-70dBm a -0dBm',
        },
    ],
    latency            : [
        {
            prinColor  : COLOR.green,
            secuColor  : 'rgb(62 97 57)',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : ok,
            secuText   : '0ms a 100ms',
        },
        {
            prinColor  : COLOR.yellow,
            secuColor  : '#B4A343',
            colorText1 : 'black',
            colorText2 : 'white',
            prinText   : alerta,
            secuText   : '100 a 500 ms'
        },
        {
            prinColor  : COLOR.red,
            secuColor  : '#8F3A36',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : alarma,
            secuText   : 'Mayor a 500 ms'
        },
    ],
    pack_inst       : [],
    temp_inst       : [
        {
            prinColor  : COLOR.green,
            secuColor  : 'rgb(62 97 57)',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : ok,
            secuText   : 'Menor a 40°C',
        },
        {
            prinColor  : COLOR.yellow,
            secuColor  : '#B4A343',
            colorText1 : 'black',
            colorText2 : 'white',
            prinText   : alerta,
            secuText   : '40°C a 70°C'
        },
        {
            prinColor  : COLOR.red,
            secuColor  : '#8F3A36',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : alarma,
            secuText   : 'Mayor a 70°C'
        },
    ],
    wire_inst       : [],
    operability     : [],
    wiredpeers      : [
        {
            prinColor  : COLOR.green,
            secuColor  : 'rgb(62 97 57)',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : ok,
            secuText   : 'Menor a 1000',
        },
        {
            prinColor  : COLOR.yellow,
            secuColor  : '#B4A343',
            colorText1 : 'black',
            colorText2 : 'white',
            prinText   : alerta,
            secuText   : '1000 a 5000'
        },
        {
            prinColor  : COLOR.red,
            secuColor  : '#8F3A36',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : alarma,
            secuText   : 'Mayor a 5000'
        },
    ],
    wirelesspeers   : [
        {
            prinColor  : COLOR.green,
            secuColor  : 'rgb(62 97 57)',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : ok,
            secuText   : 'Menor a 1000',
        },
        {
            prinColor  : COLOR.yellow,
            secuColor  : '#B4A343',
            colorText1 : 'black',
            colorText2 : 'white',
            prinText   : alerta,
            secuText   : '1000 a 5000'
        },
        {
            prinColor  : COLOR.red,
            secuColor  : '#8F3A36',
            colorText1 : 'white',
            colorText2 : 'white',
            prinText   : alarma,
            secuText   : 'Mayor a 5000'
        },
    ],
}



